import React from 'react';
import {AccessTimeOutlined, LocationOnOutlined} from '@mui/icons-material';

const BeginnerPathway = () => {

    const beginnerPath = [
        {
            label: 'Comprendre la télédétection radar',
            description: 'Vidéo "Télédétection radar du CNRS" sous-titrée en malgache, suivie de la vidéo "Pixels et paysages" pour comprendre la différence entre images optiques et radar.',
            duration: '1 heure',
            location: 'Onglet Documentaires généraux',
            bgColor: 'bg-blue-50'
        },
        {
            label: 'Bases théoriques',
            description: 'Premier chapitre du cours rédigé, avec prise de notes des points importants.',
            duration: '1h30',
            location: 'Onglet Cours rédigé',
            bgColor: 'bg-indigo-50'
        },
        {
            label: 'Cours RADAR de l\'ESA',
            description: 'Étude du Chapitre 1 du cours de l\'ESA, avec répétitions.',
            duration: '1 heure',
            location: 'Onglet cours RADAR de l\'ESA',
            bgColor: 'bg-blue-50'
        },
        {
            label: 'École d\'été Fianarantsoa',
            description: 'Power point du premier jour avec relecture et prise de notes des points importants.',
            duration: '1 heure',
            location: 'Onglet École d\'été Fianarantsoa avril 2024',
            bgColor: 'bg-indigo-50'
        },
        {
            label: 'Synthèse et échange',
            description: 'Rédaction d\'une synthèse de 2 pages A4 et échange avec les autres étudiants en groupe.',
            duration: '2 heures minimum',
            location: 'Travail personnel et en groupe',
            bgColor: 'bg-blue-50'
        },
        {
            label: 'Exploration des abrégés',
            description: 'Consultation des contenus de l\'onglet Abrégés et mots clefs pour cours et documentaires, discussion sur l\'intérêt des analyses, et participation éventuelle à la réalisation d\'autres abrégés.',
            duration: 'Variable',
            location: 'Onglet Abrégés et mots clefs',
            bgColor: 'bg-indigo-50'
        }
    ];

    return (
        <div className="mb-8">
            <div className="flex justify-center text-center items-center mb-6">
                <div>
                    <h2 className="text-2xl font-bold text-gray-900">Parcours pour débutant</h2>
                    <p className="text-gray-600">Une dizaine d'heures de formation pour acquérir les bases de la
                        télédétection radar</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {beginnerPath.map((step, index) => (
                    <div key={index}
                         className={`rounded-lg shadow-md overflow-hidden border border-gray-200 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${step.bgColor}`}>
                        {/* Card header with step number */}
                        <div className="bg-blue-600 h-2 w-full"></div>

                        <div className="p-5">
                            {/* Number badge */}
                            <div className="flex justify-between items-center mb-3">
                                <div
                                    className="bg-white text-blue-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2 border-blue-600">
                                    {index + 1}
                                </div>
                                {/* Number badge  <ArrowForwardIos className="text-blue-600 w-4 h-4" />*/}
                            </div>

                            {/* Content */}
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {step.label}
                            </h3>
                            <p className="text-gray-700 mb-4 h-24 overflow-y-auto text-sm">{step.description}</p>

                            {/* Footer with metadata */}
                            <div className="pt-2 border-t border-gray-200">
                                <div className="flex flex-wrap gap-2">
                                    <span
                                        className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800">
                                        <AccessTimeOutlined className="w-3.5 h-3.5 mr-1"/>
                                        {step.duration}
                                    </span>
                                    <span
                                        className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-800">
                                        <LocationOnOutlined className="w-3.5 h-3.5 mr-1"/>
                                        {step.location}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-6 p-4 bg-blue-50 text-blue-800 rounded-md text-sm border border-blue-200">
                <p className="font-medium">Ce parcours représente environ une dizaine d'heures de formation. À l'issue,
                    vous aurez acquis
                    les concepts fondamentaux de la télédétection radar.</p>
            </div>
        </div>
    );
};

export default BeginnerPathway;